import React, {useEffect, useState} from 'react'
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Header from "../../layout/header";
import Moment from "moment";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../Images/no-data-found.webp";
import BottomMenu from "../../layout/bottomMenu";
import {toast} from 'react-toastify';

const Listing = ({
                     taskListing,
                     listing = [],
                     history,
                     match,
                     removeTask,
                     removeTaskDetails = [],
                     taskFilter,
                     filter = []
                 }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [type, setType] = useState("")
    const [pageNo, setPage] = useState(1)
    const [open, setOpen] = useState(false);
    const [filterInputList, setFilterInputList] = useState([{}])
    const [filterView, setfilterView] = useState([{}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)

    useEffect(() => {
        (async () => {
            let type = parseInt(match?.params?.type) === 1 ? "created" : "assigned"
            setType(type)
            setIsLoading(true)
            await taskListing(1, type)
            await taskFilter()
            setIsLoading(false)
        })()
    }, []);

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected + 1)
        await taskListing(val?.selected + 1, type)
        setIsLoading(false)
    };


    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        const view = [...filterView]
        list[0][key] = value
        view[0][key] = value
        if (stringValue !== '') {
            view[0][key] = stringValue
            setfilterView(view)
        } else {
            setfilterView(view)
        }
        setFilterInputList(list)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await taskListing(pageNo, type, filterInputList)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterView[0][key]
            delete filterInputList[0][key]
            delete filterInputList[0][key + "_name"]
            setfilterView(filterView)
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await taskListing(pageNo, type, filterInputList)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setfilterView([{}])
                setFilterInputList([{}])
                setIsLoading(true)
                await taskListing(pageNo, type)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    return (
        <>
            <Loader isLoading={isLoading}/>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Task List'}
                            history={history}
                        />
                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">

                                            {/* <h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {filterView[0] !== undefined && Object.keys(filterView[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mt-20px"
                                         style={{marginTop: "36px"}}>
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterView[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterView[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row" style={{marginTop: "40px"}}>
                                    {/*CARD START*/}

                                    {listing && listing?.data !== undefined && listing?.data.length > 0 && listing?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow card-padding">
                                                        <div className="card card-just-text" data-background="color"
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category">
                                                                    {val?.status === 'Open' ?
                                                                        <div className="header-ui-item-opp"
                                                                             style={{backgroundColor: "#bea925"}}>
                                                                            Open
                                                                        </div> : val?.status === 'Completed' ?
                                                                            <div className="header-ui-item-opp">
                                                                                Completed
                                                                            </div> :
                                                                            <div className="header-ui-item-opp"
                                                                                 style={{backgroundColor: "#88130a"}}>
                                                                                Rejected
                                                                            </div>
                                                                    }
                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                            <span className="">{val?.client_name !== null ? val?.client_name : val?.account_name}</span>
                                                                        </div>
                                                                        <div className="col-2">
                                                                            {/*TOGGLE*/}
                                                                            <div className="dropdown"
                                                                                 style={{"float": "right"}}>
                                                                                <a
                                                                                    href={`task-view/${val?.id}/${match?.params?.type}`}
                                                                                    className="btn btn-sm icon-btn"
                                                                                    type="button"
                                                                                ><i className="bi bi-eye"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row list-view">
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-info-circle-fill"></i>&nbsp;&nbsp;Title
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.title}>
                                                                                        {val?.title}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Created
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.created_at).format('DD-MM-YYYY')}</div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-info-circle-fill"></i>&nbsp;&nbsp;Description
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.description}>
                                                                                        {val?.description}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Assigned
                                                                                To
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{val?.assigned_user}</div>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                    {type === "assigned" && val?.status === 'Open' &&
                                                                        <div className="row list-view-links">
                                                                            <ul>

                                                                                <li>

                                                                                </li>
                                                                                <li>
                                                                                    <a
                                                                                        href={`edit-task/${val?.id}`}><i
                                                                                        className="fas fa-edit"></i>&nbsp;&nbsp;Action
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    }

                                                                    {type === 'created'  &&
                                                                    <div className="col-sm-6">
                                                                        <a href={`save-task`}
                                                                            className="draft-float" >
                                                                            <p className="my-float" style={{marginTop:"20px"}}><i
                                                                                className="fa fa-plus"
                                                                                aria-hidden="true"></i></p>
                                                                        </a>
                                                                    </div>}
                                                                </h6>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {listing && listing?.data !== undefined && listing?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(listing?.total / listing?.per_page)}
                                                forcePage={listing?.current_page-1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {listing && listing?.data !== undefined && listing?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                            {type === 'created' &&
                                                <div className="col-sm-6">
                                                    <a href={`save-task`}
                                                       className="draft-float">
                                                        <p className="my-float" style={{marginTop: "20px"}}><i
                                                            className="fa fa-plus"
                                                            aria-hidden="true"></i></p>
                                                    </a>
                                                </div>
                                            }
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    filterContent={filter}
                    handleFilter={handleFilter}
                    handleSubmitFilter={handleSubmitFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default Listing